import { Option } from '~in-app/components/MultiSelectDropdown'

import { Address, Contact, PersonsInCharge } from './common.dto'

export interface Distributor {
  id: string
  address: Address
  code: string
  contacts: Contact[]
  createdBy: string
  createdOn: string
  desp: string
  name: string
  personsInCharge: PersonsInCharge[]
  remarks: string
  status: string
  tempPwd: string
  timezone: string
  updatedBy: string
  updatedOn: string
  version: number
  action?: string
}

export const contactTypes: Option[] = [
  {
    label: 'Business Phone',
    value: 'BUSINESS_PHONE',
  },
  {
    label: 'Mobile',
    value: 'MOBILE',
  },
  {
    label: 'Email',
    value: 'EMAIL',
  },
]

export const addressTypes: Option[] = [
  {
    label: 'Business',
    value: 'BUSINESS',
  },
  {
    label: 'Home',
    value: 'HOME',
  },
]
